import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import apiClient from '../../utils/api-client';
import getColumnClass from '../../utils/getColumnClass';
import CardSkeleton from '../Common/CardSkeleton';
import FilterBar from '../Common/FilterBar';
import GridControls from '../Common/GridControls';
import '../Shop/CategoryProductsList.css';
import ProductCard from './ProductCard';

const CategoryProductList = ({ productsData, isLoading, error }) => {
  const [sortCriteria, setSortCriteria] = useState('0');
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [categories, setCategories] = useState([]);
  const { slug } = useParams();
  const [gridSize, setGridSize] = useState(() => {
    const storeGridZize = localStorage.getItem('SearchGridSize');
    return storeGridZize ? parseInt(storeGridZize, 10) : 4;
  });
  useEffect(() => {
    localStorage.setItem('SearchGridSize', gridSize.toString());
  }, [gridSize]);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // Fetch category and all categories on slug change
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const [categoryRes, allCategoriesRes] = await Promise.all([
          apiClient.get(`/category/${slug}`),
          apiClient.get('/category'),
        ]);

        setSelectedCategory(categoryRes.data.data);
        setCategories(allCategoriesRes.data.data);
      } catch (err) {
        console.log(err);
      }
    };

    fetchCategories();
  }, [slug]);

  useEffect(() => {
    if (productsData && productsData.products) {
      setFilteredProducts(sortProducts([...productsData.products]));
    }
  }, [productsData, sortCriteria]);

  const handleSortChange = (event) => {
    setSortCriteria(event.target.value);
  };

  const sortProducts = (products) => {
    switch (sortCriteria) {
      case 'featured':
        return products.sort((a, b) => b.is_featured - a.is_featured);
      case 'new_arrival':
        return products.sort(
          (a, b) => new Date(b.time_stamp) - new Date(a.time_stamp)
        );
      case 'biggest_discount':
        return products.sort((a, b) => {
          const maxDiscountA = Math.max(
            ...a.varients.map((v) => v.discount_percent)
          );
          const maxDiscountB = Math.max(
            ...b.varients.map((v) => v.discount_percent)
          );
          return maxDiscountB - maxDiscountA;
        });
      case 'low_to_high':
        return products.sort((a, b) => {
          const minPriceA = Math.min(...a.varients.map((v) => v.final_price));
          const minPriceB = Math.min(...b.varients.map((v) => v.final_price));
          return minPriceA - minPriceB;
        });
      case 'high_to_low':
        return products.sort((a, b) => {
          const minPriceA = Math.min(...a.varients.map((v) => v.final_price));
          const minPriceB = Math.min(...b.varients.map((v) => v.final_price));
          return minPriceB - minPriceA;
        });
      default:
        return products;
    }
  };

  return (
    <>
      <FilterBar
        handleSortChange={handleSortChange}
        products={filteredProducts}
        categories={categories}
      />

      <GridControls
        gridSize={gridSize}
        setGridSize={setGridSize}
        windowWidth={windowWidth}
      />
      <div className="row mt-3">
        {error && <em className="form_error">{error}</em>}
        {isLoading && <CardSkeleton cards={4} />}
        {filteredProducts &&
          filteredProducts.map((product, index) => (
            <div
              className={`${getColumnClass(gridSize, windowWidth)} p-2`}
              key={index}
            >
              <ProductCard product={product} />
            </div>
          ))}
      </div>
    </>
  );
};

export default CategoryProductList;
